import { CustomerLevel, ProductStatus, ProductType } from '@/enums'
import { useAuthStore } from '@/pinia/auth'
import { useCustomerStore } from '@/pinia/customer'
import { useStyleStore } from '@/pinia/style'
import { computed } from 'vue'

export function useAuthorisation() {
  const authStore = useAuthStore()
  const customerStore = useCustomerStore()
  const styleStore = useStyleStore()
  const customer = customerStore.customer?.customer

  const hasBaseAccess = computed(() => {
    return customer?.customerLevel >= CustomerLevel.BASE
  })

  const hasFullAccess = computed(() => {
    if (isLeadGenOnly.value) {
      return false
    }
    if (authStore.isBusiness) {
      return true
    }
    return customer?.customerLevel >= CustomerLevel.FULL
  })

  const hasFullAccessLeadGenOnly = computed(() => {
    return customer?.customerLevel >= CustomerLevel.FULL && isLeadGenOnly.value
  })

  const hasFabricatorPaperwork = computed(() => {
    return customer?.fabricationPaperworkEnabled
  })

  const isLeadGenOnly = computed(() => {
    return styleStore.fabricator?.accountProductStatus === ProductStatus.LEAD_GEN_ONLY
  })

  const isLeadCapturePortal = computed(() => {
    return customerStore.isBrandedModeEnabled && authStore.isPortal
  })

  const isLeadCaptureAdmin = computed(() => {
    return authStore.licenses.some((x) => x.type === ProductType.DEALER)
  })

  return {
    hasBaseAccess,
    hasFullAccess,
    hasFullAccessLeadGenOnly,
    hasFabricatorPaperwork,
    isLeadGenOnly,
    isLeadCapturePortal,
    isLeadCaptureAdmin
  }
}
